export const GRID_WIDTH = 25;
export const GRID_HEIGHT = 15;
export const GRID_SIZES = [
  { width: 25, height: 15 }
];
export const COLORS = ["red", "blue", "green", "yellow", "purple", "orange"];

// AI difficulty presets
export const AI_DIFFICULTIES = [
  { id: "easy", label: "Easy" },
  { id: "normal", label: "Normal" },
  { id: "hard", label: "Hard" }
];

export const DEFAULT_DIFFICULTY = "normal";